import * as React from 'react'
import Login from '../components/Login'
import Layout from '../components/Layout'

const IndexPage = () => <Login />

export default IndexPage
